export default __webpack_public_path__ + "static/media/field-binary.6e0cdb24.svg";